import { useQuery } from "@apollo/client";
import useLocale from "@RHCommerceDev/hooks-use-locale";
import { useCountry } from "@RHCommerceDev/hooks/useCountry";
import useSite from "@RHCommerceDev/hooks/useSite";
import {
  queryCatalogNavigation,
  querySaleCatalogNavigation
} from "graphql-client/queries/navigation";

const useGetNavigation = () => {
  const siteId = useSite();
  const countryCode = useCountry();
  const locale = useLocale();

  const { data: { catalogNavigation } = {}, refetch } = useQuery(
    queryCatalogNavigation,
    {
      variables: {
        siteId,
        locale,
        countryCode,
        nextgenPg: "true"
      }
    }
  );

  const { data: { saleCatalogNavigation } = {}, refetch: refetchSaleCatalog } =
    useQuery(querySaleCatalogNavigation, {
      variables: {
        siteId,
        filter: "sale",
        locale,
        countryCode,
        nextgenPg: "true"
      }
    });

  return {
    catalogNavigation,
    saleCatalogNavigation,
    refetchCatalogNavigation: refetch,
    refetchSaleCatalogNavigation: refetchSaleCatalog
  };
};

export default useGetNavigation;
